(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-score/assets/javascripts/event-participant-distributions.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-score/assets/javascripts/event-participant-distributions.js');
"use strict";


const TrendIndicator = svs.components.tipsen.trendIndicator.TrendIndicator;
const EventParticipantDistributions = _ref => {
  let _ref$distributions = _ref.distributions,
    distributions = _ref$distributions === void 0 ? [] : _ref$distributions,
    _ref$drawId = _ref.drawId,
    drawId = _ref$drawId === void 0 ? '' : _ref$drawId;
  if (!Array.isArray(distributions) || distributions.length === 0) {
    return null;
  }
  const classBlockName = 'pg_coupon_row__event__participant__distributions';
  return React.createElement("div", {
    className: "pg_coupon_row__event__participant__distributions"
  }, React.createElement("div", {
    className: "".concat(classBlockName, "__values")
  }, distributions.map((distribution, index) => {
    const key = "".concat(drawId, "_").concat(index);
    return React.createElement(TrendIndicator, {
      id: key,
      key: key,
      suffix: "%",
      value: distribution || 0
    });
  })));
};
setGlobal('svs.components.tipsen.couponScore.EventParticipantDistributions', EventParticipantDistributions);

 })(window);